import { Typography } from "@mui/material";

import { ErrorMessage, Field, useFormikContext } from "formik";
import TextError from "../TextError";
import React, { useEffect } from "react";
import axios from "axios";
import { addNewFormOnBlur, ageValidation, premiumProposedValidation, validateShareOfNominee } from "../../../Utilities/LifeInsuranceCustomValidation/shriRamCustomValidation";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";


function InputFields(props) {
  const {
    label,
    nomineeArray,
    setnomineeArray,
    name,
    validation,
    customeValidation,
    transperData,
    type,
    setNomineeShare,
    nomineeShare,
    arrayindex,
    readOnly,
    hidden,
    array,
    manualValidation,
    url,
    schemeId,
    errors,
    parentname,
    AddHandler,
    DeleteHandler,
    ...rest
  } = props;

  const { values: populatedForms } = useFormikContext();
  
  useEffect(() => {}, []);

  function validate(val) {
    if (name === `nomineeDetails[${arrayindex}].ShareofNominee`) {
      return validateShareOfNominee(populatedForms, arrayindex, DeleteHandler);
    }else if(name ==='Age'){
      return ageValidation(name,val)
    }else if(name === 'PremiumProposed'){
      return premiumProposedValidation(name,val)
    }
    return null;
  }


  return (
    <div>
      <div>
        <Typography className="form-label">{hidden ? null : label}</Typography>

        <Field name={name}>
          {({ form, field }) => {
            const { setFieldValue, setFieldError } = form;
            const { values } = form;

            const handleChange = (val) => {
              // const totalArray=[]
              const { value } = val.target;
              
              const SplittedName = name.split(".");
              let Aindex = [];
              SplittedName.map((Sname, ind) => {
                if (Sname.indexOf("[") !== -1) {
                  const splitedSname = Sname.split("[");
                  Aindex.push(splitedSname[1][0]);
                } else {
                }
              });

              

              setFieldValue(name, val.target.value);

              /* if(name ==='Age'){
                console.log('lkl',typeof(val.target.value))
                if(Number(val.target.value) >= 18 && Number(val.target.value) <= 55  ){
                  setFieldValue(name, val.target.value);

                }else{
                  alert('age not valid')
                  //setFieldValue(name, "");

                }
              } */

             /*  if (name === "primaryDetails.LifeAssured.FirstName") {
                setFieldValue("Proposer.FirstName", value);
              } else if (name === "primaryDetails.LifeAssured.LastName") {
                setFieldValue("Proposer.LastName", value);
              } else if (name === "primaryDetails.LifeAssured.MiddleName") {
                setFieldValue("Proposer.MiddleName", value);
              } else if (name === "primaryDetails.LifeAssured.DateOfBirth") {
                setFieldValue("Proposer.DateOfBirth", value);
              } */

              if (name === `primaryDetails.Address[${arrayindex}].PinCode`) {
                console.log("do pin",value);
                console.log("dc", value, name, arrayindex, array);
                let domain = "";
                if (window.location.hostname === "localhost") {
                  domain = process.env.REACT_APP_LOCAL_DJANGO;
                } else if (
                  window.location.hostname.trim() === "acuvisor.com"
                ) {
                  domain = process.env.REACT_APP_PRODUCTION_DJANGO;
                } else {
                  domain = process.env.REACT_APP_UAT_DJANGO;
                }

                axiosInstance
                  .get(
                    `/api/shriram/pincode/${value}`
                  )
                  .then((response) => {
                    console.log('pincode resp',response)
                    if(Object.keys(response.data).length >0){
                      let Area = response.data.Area
                      let City = response.data.City
                      setFieldValue(`primaryDetails.Address[${arrayindex}].Area`, Area);
                      setFieldValue(`primaryDetails.Address[${arrayindex}].CityOrTown`, City);

                    }
                  });
              }
            };

            const handleBlur = (val) => {
              const { name, value } = val.target;
              
              if (name === `nomineeDetails[${arrayindex}].ShareofNominee`) {
                addNewFormOnBlur(
                  populatedForms,
                  AddHandler
                );

              }
            };

            return (
              <>
                {readOnly !== undefined ? (
                  <Field
                    className="form-control"
                    label={label}
                    {...rest}
                    id={name}
                    hidden={hidden}
                    disabled={Boolean(readOnly)}
                    name={name}
                    {...rest}
                    min={type === "number" ? "0" : null}
                    placeholder={label}
                    // validate = {validate}
                  />
                ) : (
                  <Field
                    className="form-control"
                    label={label}
                    {...rest}
                    id={name}
                    hidden={hidden}
                    //value={populatedForms[name]}
                    type={type}
                    name={name}
                    min={type === "number" ? "0" : null}
                    {...rest}
                    placeholder={label}
                    onChange={(val) => handleChange(val, name)}
                    onBlur={(val) => handleBlur(val, name)}
                    validate = {validate}
                    onWheel={(e) =>
                      type === "number" ? e.currentTarget.blur() : null
                    }
                  />
                )}
              </>
            );
          }}
        </Field>
        <ErrorMessage name={name} component={TextError} />
      </div>
    </div>
  );
}

export default InputFields;
